export enum PermissionEnum {
	NATIONAL_ADMIN = 'national_admin',
	NATIONAL_VALIDATOR = 'national_validator',
	NATIONAL_DGOS = 'national_dgos',
	LIQUIDATOR = 'liquidator',
	LIQUIDATOR_MANAGER = 'liquidator_manager',
	CPAM_SUPERVISOR = 'cpam_supervisor',
	EVALUATION_TC = 'evalution_tc',
	EVALUATION_DM = 'evalution_dm'
}

export enum PagePermissionEnum {
	CONNECTED = 'connected',
	PATIENT = 'patient_page',
	PATIENT_PCR = 'pcr_patient_page',
	PATIENT_IDEL = 'patient_idel_page',
	PATIENT_IDEL_VALIDATOR = 'patient_idel_validator_page',
	PATIENT_FILE = 'patient_file_page',
	PROJECT = 'project_page',
	PROJECT_LIST = 'projects_list',
	IMPORT = 'import_page',
	IMPORT_LIST = 'import_list_page',
	REMUNERATION = 'remuneration_page',
	IMPORT_CONTACT = 'import_contact_page',
	IMPORT_ACTOR = 'import_actor_page',
	PAYMENTS_VALIDATION_EXP = 'payments_validation_exp',
	PAYMENTS_LIQUIDATION_EXP = 'payments_liquidation_exp',
	PAYMENTS_SUPERVISION_EXP = 'payments_supervision_exp',
	PAYMENTS_ADMINISTRATION_EXP = 'payments_administration_exp',
	PAYMENTS_LIST_EXP = 'payments_list_exp',
	PAYMENTS_VALIDATION_PCR = 'payments_validation_pcr',
	PAYMENTS_LIQUIDATION_PCR = 'payments_liquidation_pcr',
	PAYMENTS_SUPERVISION_PCR = 'payments_supervision_pcr',
	PAYMENTS_ADMINISTRATION_PCR = 'payments_administration_pcr',
	PAYMENTS_LIST_PCR = 'payments_list_pcr',
	PAYMENTS_SUPERVISION_DGOS = 'payments_supervision_dgos',
	PAYMENTS_ADMINISTRATION_DGOS = 'payments_administration_dgos',
	PAYMENTS_VALIDATION_DGOS = 'payments_validation_dgos',
	PAYMENTS_LIST_DGOS = 'payments_list_dgos',
	EXPORTS_ADMINISTRATION = 'exports_administration',
	EXPORTS_LIQUIDATION = 'exports_liquidation',
	EXPORTS_PAYMENT = 'export_payment_list',
	EXPORTS_SUPERVISION = 'exports_supervision',
	EXPORTS_VALIDATION = 'exports_validation',
	EXPORTS_EVAL_TC = 'exports_third_party_appraiser',
	EXPORTS_EVAL_DM = 'exports_data_manager_appraiser',
	EXPORTS_CONTROL_FILE_TC = 'exports_third_party_control_file',
	EXPORTS_CONTROL_FILE_DM = 'exports_data_manager_control_file',
	EXPORTS_DGOS = 'exports_dgos',
	PAYMENT_ADD = 'payment_add',
	DIRECT_IMPORT_PATIENT = 'direct_import_patient',
	DIRECT_IMPORT_UNDUE = 'direct_import_undue',
	ACTORS_LIST = 'actors_list',
	IMPORT_STORED_FILE = 'stored_file_page',
	IMPORT_STORED_FILE_LIST = 'stored_file_list_page',
	IMPORT_ADMINISTRATION = 'import_administration',
	IMPORT_CONTROL_FILE = 'control_file_page',
	PROJECT_GROUP = 'project_group',
	PROJECT_PAYMENTS_LIST = 'project_payments_list',
	PROJECT_EXPORTS_LIST = 'project_exports_list',
	DOC = 'doc',
	DATA_LINES_LIST = 'data_lines_list',
	USERS_ACTORS_LIST = 'users_actors_list',
	IDEL_ACTORS_LIST = 'idel_actors_list',
	SURVEY_CAMPAIGN = 'survey_campaign',
	EXPERIENCE_PATIENT_ADMINISTRATION = 'exp_patient_administration',
	IMPORT_PCR = 'import_pcr_page',
	UNDUE_LIST = 'undue_list',
	UNDUE_ADD = 'undue_add',
	UNDUE_LIST_AM = 'list_undue_accessmaster',
	UNDUE_ADD_AM = 'add_undue_accessmaster'
}

export enum ActionPermissionEnum {
	ADDRESSING_ADD = 'addressing_add',
	ADDRESSING_DELETE = 'addressing_delete',
	USER_CREATE = 'user_create',
	PROJECT_EDIT = 'project_edit',
	PATIENT_ADD = 'patient_add',
	PATIENT_DELETE = 'patient_delete',
	PATIENT_PCR_ADD = 'patient_pcr_add',
	PATIENT_IDEL_ADD = 'patient_IDEL_add',
	PATIENT_IDEL_DELETE = 'patient_IDEL_delete',
	ACTOR_ADD = 'actor_add',
	ACTOR_EDIT = 'actor_edit',
	ACTOR_DELETE = 'actor_delete',
	FILE_STORAGE_DELETE = 'file_storage_delete',
	FILE_STORAGE_DOWNLOAD = 'file_storage_download',
	CONTACT_DELETE = 'contact_delete',
	CONTACT_DOWNLOAD = 'contact_download',
	SEARCH_NIR = 'search_nir',
	SEARCH_SPECIALTIES = 'search_specialties',
	IMPORT_DOWNLOAD = 'import_download_page',
	ACTOR_IMPORT_DOWNLOAD = 'actor_import_download',
	IMPORT_UNDUE_DOWNLOAD = 'import_undue_download',
	IMPORT_DELETE = 'import_delete',
	IMPORT_PATIENT_DOWNLOAD = 'import_patient_download',
	IMPORT_REMUNERATION_DOWNLOAD = 'import_remuneration_download',
	DATA_LINE_ADD = 'data_line_add',
	USER_ACTOR_ADD = 'user_actor_add',
	USER_ACTOR_EDIT = 'user_actor_edit',
	USER_ACTOR_DELETE = 'user_actor_delete',
	IDEL_ACTOR_ADD = 'idel_actor_add',
	IDEL_ACTOR_DELETE = 'idel_actor_delete',
	EXPORT_PAYMENT_ADD = 'export_payment_add',
	PCR_DELETE = 'pcr_delete',
	PCR_DOWNLOAD = 'pcr_download',
	SURVEY_CAMPAIGN_EDIT = 'survey_campaign_edit',
	UNDUE_ADD = 'undue_add',
	UNDUE_UPDATE = 'undue_update',
	UNDUE_DELETE = 'undue_delete',
	IMPORT_CONTROL_FILE_DELETE = 'control_file_page_delete',
	IMPORT_CONTROL_FILE_DOWNLOAD = 'control_file_page_download',
	PAYMENT_RECEIPT_GENERATE = 'payment_receipt_generate'
}
